import * as types from "../actions/actionTypes";

export default function signinReducer(state = null, action) {
  switch (action.type) {
    case types.USER_SIGNED_IN_SUCCESS:
      return action.value;

    case types.USER_SIGNED_OUT_SUCCESS:
      return action.signedinuserobject;

    default:
      return state;
  }
}
